const _existingDropdownItemIndex = (existingNavigationItems, newNavigationItem) => {
  if (!newNavigationItem.children) {
    return -1;
  }
  return existingNavigationItems.findIndex(
    ({ description, children }) => newNavigationItem.description === description && children
  );
};
const mergeNavigationItems = (navigationItems) => navigationItems.reduce((result, current) => {
  const existingDropdownItemIndex = _existingDropdownItemIndex(result, current);
  if (existingDropdownItemIndex >= 0) {
    const existingDropdownItem = result[existingDropdownItemIndex];
    const newDropdownItem = {
      ...current,
      ...existingDropdownItem,
      children: [...existingDropdownItem.children, ...current.children]
    };
    const newResult = [...result];
    newResult[existingDropdownItemIndex] = newDropdownItem;
    return newResult;
  }
  return [...result, current];
}, []);
export default mergeNavigationItems;
